import activites from "../../../Forms/activities.json";
import React from "react";

const SuggestedActivities = ({
  alreadySelectedActivities = [],
  companyActivityStr = "",
  onAddActivite,
}) => {
  const findActivities = () => {
    // Si aucune activité n'est fournie, retourner un tableau vide
    if (!companyActivityStr || companyActivityStr.trim() === "") {
      return [];
    }

    // Convertir la chaîne d'activité en minuscules pour une recherche insensible à la casse
    const activityLower = companyActivityStr.toLowerCase();

    // Extraire les mots de plus de 2 lettres
    const words = activityLower.split(/\s+/).filter((word) => word.length > 2);

    // Si aucun mot valide n'est trouvé, retourner un tableau vide
    if (words.length === 0) {
      return [];
    }

    // Créer des combinaisons de mots (paires de mots adjacents)
    const combinations = [];
    for (let i = 0; i < words.length - 1; i++) {
      combinations.push(`${words[i]} ${words[i + 1]}`);
    }

    // Rechercher des correspondances dans les activités
    const matches = activites.filter((activity) => {
      // Ignorer les activités déjà sélectionnées
      if (
        alreadySelectedActivities.includes(activity.id.toString()) ||
        alreadySelectedActivities.includes(activity.id)
      ) {
        return false;
      }

      // Convertir le nom de l'activité en minuscules
      const activityName = activity.name.toLowerCase();

      // Vérifier si un mot ou une combinaison correspond au nom de l'activité
      const wordMatch = words.some((word) => activityName.includes(word));
      const combinationMatch = combinations.some((combo) =>
        activityName.includes(combo)
      );

      // Vérifier les alias si disponibles
      let aliasMatch = false;
      if (activity.alias) {
        try {
          // Les alias sont stockés sous forme de chaîne JSON
          const aliases = JSON.parse(activity.alias);
          aliasMatch = aliases.some((alias) => {
            if (!alias || alias === "") return false;
            const aliasLower = alias.toLowerCase();
            return (
              words.some((word) => aliasLower.includes(word)) ||
              combinations.some((combo) => aliasLower.includes(combo))
            );
          });
        } catch (e) {
          // En cas d'erreur de parsing, ignorer les alias
          console.error(
            "Erreur de parsing d'alias pour l'activité",
            activity.id
          );
        }
      }

      return wordMatch || combinationMatch || aliasMatch;
    });

    // Trier les résultats par pertinence (nombre de mots correspondants)
    return matches
      .sort((a, b) => {
        const scoreA = getMatchScore(a, words, combinations);
        const scoreB = getMatchScore(b, words, combinations);
        return scoreB - scoreA; // Tri décroissant
      })
      .slice(0, 5); // Limiter à 5 suggestions
  };

  // Fonction pour calculer un score de pertinence
  const getMatchScore = (activity, words, combinations) => {
    const activityName = activity.name.toLowerCase();
    let score = 0;

    // Points pour les correspondances de mots
    words.forEach((word) => {
      if (activityName.includes(word)) score += 1;
    });

    // Points supplémentaires pour les correspondances de combinaisons
    combinations.forEach((combo) => {
      if (activityName.includes(combo)) score += 2;
    });

    // Points pour les correspondances d'alias
    if (activity.alias) {
      try {
        const aliases = JSON.parse(activity.alias);
        aliases.forEach((alias) => {
          if (!alias || alias === "") return;
          const aliasLower = alias.toLowerCase();
          words.forEach((word) => {
            if (aliasLower.includes(word)) score += 0.5;
          });
          combinations.forEach((combo) => {
            if (aliasLower.includes(combo)) score += 1;
          });
        });
      } catch (e) {
        // Ignorer les erreurs de parsing
      }
    }

    return score;
  };

  // Obtenir les activités suggérées
  const suggestedActivities = findActivities();

  // Si aucune suggestion n'est trouvée, ne rien afficher
  if (suggestedActivities.length === 0) {
    return null;
  }

  return (
    <div
      className="d-flex flex-wrap mt-4"
      style={{
        gap: 8,
      }}
    >
      <div className="text-primary font-weight-bold mb-2">
        Activités suggérées pour votre entreprise
      </div>
      <div className="d-flex flex-wrap" style={{ gap: 8 }}>
        {suggestedActivities.map((activity) => (
          <button
            key={activity.id}
            className="btn btn-link bg-default text-left px-3 py-2 text-sm btn-small shadow-small"
            type="button"
            onClick={() =>
              onAddActivite({
                target: { value: activity.id },
              })
            }
            style={{
              fontSize: 13,
              maxWidth: 400,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              color: "var(--primary)",
              textDecoration: "none",
            }}
          >
            <i className="fa fa-plus mr-2" />
            {activity.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedActivities;
